import { useEffect } from "react";
import { Link, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData, selectUserToken } from "../../../features/userSlice";
import { setIsCatalogueLoading } from "../../../features/fetcherSettingsSlice";
import { FetcherSettingsEndPointLogic } from "../../../logic/DataCollection/FetcherSettings/FetcherSettingsEndPointLogic";
import {
  FETCHER_SETTINGS_CATALOGUE_QUERY_ID,
  FETCHER_SETTINGS_DETAILS_QUERY_ID,
  FETCHER_SETTINGS_DEV_ITEM_ID,
  FETCHER_SETTINGS_DEV_LEVEL,
  // getFirstDimension,
  getFirstWebsiteSharedUid,
} from "./helpers/fetcherSettingsQueryIds";
import FetcherSettingsTabs from "./FetcherSettingsTabs";
import "./FetcherSettings.css";

const FetcherSettings = () => {
  const dispatch = useDispatch();
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const userData = useSelector(selectUserData);
  const websiteSharedUid = getFirstWebsiteSharedUid(userData);
  //const dimension = getFirstDimension(userData);

  useEffect(() => {
    if (!oauthTokenHeader || !websiteSharedUid) return;
    const loadFetcherSettings = async () => {
      try {
        dispatch(setIsCatalogueLoading(true));
        // the catalogue and the dev objects are independent reads, so they run
        // together and the screen waits once rather than twice
        await Promise.all([
          FetcherSettingsEndPointLogic.getFetcherSettingsData({
            oauthTokenHeader,
            queryId: FETCHER_SETTINGS_CATALOGUE_QUERY_ID,
            websiteSharedUids: [websiteSharedUid],
            // dimension: [dimension],
          }),
          FetcherSettingsEndPointLogic.getFetcherSettingsDevObjsData({
            oauthTokenHeader,
            queryId: FETCHER_SETTINGS_DETAILS_QUERY_ID,
            websiteSharedUids: [websiteSharedUid],
            item_id: FETCHER_SETTINGS_DEV_ITEM_ID,
            level: FETCHER_SETTINGS_DEV_LEVEL,
          }),
        ]);
      } catch (e: any) {
        console.error("Error loading fetcher settings:", e);
      } finally {
        dispatch(setIsCatalogueLoading(false));
      }
    };
    loadFetcherSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Paper elevation={0}>
      <Box sx={{ padding: "16px 16px 0px" }}>
        <Typography variant="h3" sx={{ fontSize: "24px" }}>
          Fetcher Settings
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontSize: "14px", maxWidth: "620px", mt: 0.5 }}
        >
          Maintain the Fetcher catalogue — the platforms we collect from.
          Connecting a brand to a config happens on the brand&apos;s{" "}
          <Link href="/operations/brands" color="secondary" underline="always">
            Manual Configuration
          </Link>{" "}
          screen.
        </Typography>
      </Box>

      <FetcherSettingsTabs />
    </Paper>
  );
};

export default FetcherSettings;
